import _objectWithoutProperties from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["analyticsProps"];
// TODO: blocked on @webtv/time
// import { toNowTimezoneString } from '@peloton/time';
import { createWorkoutWithAnalytics, workoutDetailsWithMuscleGroupScore as workoutDetails, getUserWorkoutsWithMuscleGroupScore as getUserWorkouts, getWorkoutAchievements, getWorkoutSummary, getWorkoutPerformanceGraphWithHasAppleWatchMetrics as getWorkoutPerformanceGraph } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';

var createWorkout = function createWorkout() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  var pelotonPlatform = arguments.length > 1 ? arguments[1] : undefined;

  var _ref = arguments.length > 2 ? arguments[2] : undefined;

  var analyticsProps = _ref.analyticsProps,
      params = _objectWithoutProperties(_ref, _excluded);

  return createWorkoutWithAnalytics(api, analyticsProps, pelotonPlatform, {
    pelotonId: params.pelotonId,
    isDigital: true,
    deviceType: 'web',
    streamSubscriptionId: params.streamSubscriptionId,
    streamSubscriptionIdType: params.streamSubscriptionIdType
  }, 'en-us');
};

export var toCreateWorkoutKey = function toCreateWorkoutKey(pelotonId) {
  return "CreateWorkout".concat(pelotonId);
};
export var toWorkoutFetchers = function toWorkoutFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  var pelotonPlatform = arguments.length > 1 ? arguments[1] : undefined;
  return {
    CreateWorkout: toFetcher(function (params) {
      return toCreateWorkoutKey(params.pelotonId);
    }, function (params) {
      return unwrap(function () {
        return createWorkout(api, pelotonPlatform, params);
      });
    }, {
      revalidateIfStale: true
    }),
    WorkoutDetails: toFetcher(function (params) {
      return "WorkoutDetails".concat(params.workoutId);
    }, function (params) {
      return unwrap(function () {
        return workoutDetails(api, params.workoutId);
      });
    }),
    GetWorkoutPerformanceGraph: toFetcher(function (params) {
      return "GetWorkoutPerformanceGraph".concat(params.workoutId);
    }, function (params) {
      return unwrap(function () {
        return getWorkoutPerformanceGraph(api, params);
      });
    }),
    GetUserWorkouts: toFetcher(function (params) {
      return "GetUserWorkouts".concat(JSON.stringify(params));
    }, function (params) {
      return unwrap(function () {
        return getUserWorkouts(api, params.userId, undefined, // acceptLanguage
        pelotonPlatform, params.limit, params.page, params.before, params.after, undefined, params.to, params.from, params.statsTo, params.statsFrom, {
          query: {
            joins: 'ride'
          }
        });
      });
    }, {
      revalidateOnMount: true,
      revalidateOnFocus: false
    }),
    GetWorkoutAchievements: toFetcher(function (params) {
      return "GetWorkoutAchievements".concat(params.workoutId);
    }, function (params) {
      return unwrap(function () {
        return getWorkoutAchievements(api, params.workoutId, params.acceptLanguage, params.options);
      });
    }),
    GetWorkoutSummary: toFetcher(function (params) {
      return "GetWorkoutSummary".concat(params.workoutId);
    }, function (params) {
      return unwrap(function () {
        return getWorkoutSummary(api, params.workoutId, params.options);
      });
    })
  };
};